import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { API_PATH } from '../../../shared/globals';

@Component({
  selector: 'app-booking-details-excess',
  templateUrl: './booking-details-excess.component.html',
  styleUrls: ['./booking-details-excess.component.scss']
})
export class BookingDetailsExcessComponent implements OnInit, OnChanges {

  @Input()
  appCopy = null;

  @Input()
  selectedLanguage = null;

  @Input()
  adminBookingDetails;

  @Input()
  adminBookingDetailsLoaded;

  @Input()
  bookingRef;

  public excessBaggagePayment = null;
  public receiptImg = '';
  public currencySymbol = '';
  public productType;

  constructor(
    private _router: Router
  ) {}

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof changes.adminBookingDetailsLoaded !== 'undefined') {
      if (changes.adminBookingDetailsLoaded.currentValue) {
        this.excessBaggagePayment = this.adminBookingDetails.bookingJourneyDetails[0].excessBaggagePayment;
        this.currencySymbol = this.adminBookingDetails.bookingJourneyDetails[0].paymentDetails.currencySymbol;
        this.productType = this.adminBookingDetails.bookingJourneyDetails[0].addOnProductsOverview[0].addOnProductType
        if (this.excessBaggagePayment !== null) {
          this.receiptImg =  this.excessBaggagePayment.receiptImageURL;
        }
      }
    }
  }

  redirectToSettings(event, type) {
    event.preventDefault();
    const redirectUrl = `my-account/settings-override?ref=${this.bookingRef}&type=${type}`;
    this._router.navigateByUrl(redirectUrl);
  }

}
